import { TextField as BaseTextField } from "@material-ui/core";
import React from "react";
import { useController } from "react-hook-form";

const TextField: FC<
  { name: string } & React.ComponentProps<typeof BaseTextField>
> = (props) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error },
  } = useController({ name: props.name });

  const errorMessage = error?.message;

  return (
    <BaseTextField
      onChange={onChange}
      onBlur={onBlur}
      inputRef={ref}
      error={!!error}
      helperText={errorMessage}
      // This is to stop the uncontrolled to controlled warning when a default value has not been
      // given to this form value
      value={value ?? ""}
      {...props}
    />
  );
};

export default TextField;
